import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { toast } from "sonner";
import { UserCheck } from "lucide-react";
import { submitServiceRequest } from "../../mock";

export const ExpertHelpDialog = ({ service, prefillDetails }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpenChange = (o) => {
    setOpen(o);
    if (o) setDetails(prefillDetails);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await submitServiceRequest({ ...form, service, details });
      toast.success(result.message);
      setOpen(false);
      setForm({ name: "", email: "", phone: "" });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="get-expert-help-btn" className="bg-brand-orange hover:bg-brand-orange-dark text-white">
          <UserCheck className="h-4 w-4 mr-2" /> Get Expert Help
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Get Expert Help</DialogTitle>
          <DialogDescription>Our tax experts will review your scenario and get back to you</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="eh-name">Full Name *</Label>
            <Input id="eh-name" data-testid="expert-help-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="eh-email">Email *</Label>
            <Input id="eh-email" data-testid="expert-help-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="eh-phone">Phone *</Label>
            <Input id="eh-phone" data-testid="expert-help-phone" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="eh-details">Your Tax Scenario</Label>
            <Textarea id="eh-details" data-testid="expert-help-details" rows={6} value={details} onChange={(e) => setDetails(e.target.value)} className="text-sm" />
            <p className="text-xs text-brand-muted mt-1">Pre-filled from your calculation — edit if needed</p>
          </div>
          <Button type="submit" data-testid="expert-help-submit-btn" className="w-full bg-brand-orange hover:bg-brand-orange-dark text-white" disabled={loading}>
            {loading ? "Submitting..." : "Request Expert Review"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
